import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from '../api/axios';
import styles from './Register.module.css';
import { useNavigate } from 'react-router-dom';

const Register: React.FC = () => {
  const navigate = useNavigate();
  const captchaRef = useRef<ReCAPTCHA>(null); // ✅ Moved inside component
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    acceptedTerms: false,
    acceptedPrivacyPolicy: false
  });
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const token = captchaRef.current?.getValue();
    if (!token) {
      setError('Please complete the CAPTCHA');
      return;
    }

    if (!formData.acceptedTerms || !formData.acceptedPrivacyPolicy) {
      setError('You must accept the Terms of Service and Privacy Policy to register');
      return;
    }

    try {
      await axios.post('/auth/register', {
        Username: formData.username,
        Email: formData.email,
        Password: formData.password,
        CaptchaToken: token,
        AcceptedTerms: formData.acceptedTerms,
        AcceptedPrivacyPolicy: formData.acceptedPrivacyPolicy
      });

      navigate('/login');
    } catch (err: any) {
      setError(err.response?.data || 'Registration failed');
    }
  };

  return (
    <div className={styles.registerContainer}>
      <form className={styles.registerForm} onSubmit={handleSubmit}>
        <h2>Register</h2>
        {error && <p className={styles.error}>{error}</p>}

        <input type="text" name="username" placeholder="Username" onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
        <input type="password" name="password" placeholder="Password" onChange={handleChange} required />

        <div className={styles.consentGroup}>
          <label className={styles.consentLabel}>
            <input
              type="checkbox"
              name="acceptedTerms"
              checked={formData.acceptedTerms}
              onChange={handleChange}
              required
            />
            I accept the <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" className={styles.consentLink}>Terms of Service</a>
          </label>
        </div>

        <div className={styles.consentGroup}>
          <label className={styles.consentLabel}>
            <input
              type="checkbox"
              name="acceptedPrivacyPolicy"
              checked={formData.acceptedPrivacyPolicy}
              onChange={handleChange}
              required
            />
            I accept the <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className={styles.consentLink}>Privacy Policy</a>
          </label>
        </div>

        <ReCAPTCHA
          ref={captchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
          onChange={(token) => {
            // Not needed anymore but can keep for debugging:
            console.log('CAPTCHA resolved:', token);
          }}
        />

        <button type="submit" className="button">Register</button>
      </form>
    </div>
  );
};

export default Register;
